"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personaGuardianInvitesResultFactory = void 0;
const Factory = require("factory.ts");
const persona_guardian_invite_factory_1 = require("./persona-guardian-invite.factory");
const guardian_invite_persona_factory_1 = require("./guardian-invite-persona.factory");
exports.personaGuardianInvitesResultFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    persona: guardian_invite_persona_factory_1.guardianInvitePersonaFactory.build(),
    guardian_invites: persona_guardian_invite_factory_1.personaGuardianInviteFactory.buildList(2),
});
